import { mockApiDocumentationLinkQueryQuery } from '__generated__';

export const handlers = [
  mockApiDocumentationLinkQueryQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        apiDocumentationLink: 'https://stag-api.sumologic.net/docs/sec/',
      })
    );
  }),
];
